import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"

import "./index.vue?vue&type=style&index=0&id=016dbe9b&lang=scss"

const __exports__ = script;

export default __exports__